import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  BellRing, 
  Menu,
  Users, 
  FileText, 
  Clock
} from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';

const Navbar = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const notifications = [
    // { id: 1, title: 'Sarah Thompson invited you to collaborate', time: '2 hours ago', type: 'invitation' },
    // { id: 2, title: 'Revenue report "Q1 Summary" has been updated', time: '5 hours ago', type: 'update' },
    // { id: 3, title: 'Expense report is due tomorrow', time: '1 day ago', type: 'reminder' },
  ];

  const toggleNotifications = () => setShowNotifications(!showNotifications);
  const toggleProfileMenu = () => setShowProfileMenu(!showProfileMenu);

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 z-10">
      <div className="px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        {/* Left section */}
        <div className="flex items-center">
          <button 
            onClick={toggleSidebar}
            className="md:hidden p-2 mr-2 text-gray-700 hover:text-gray-900"
          >
            <Menu className="h-6 w-6" />
          </button>
          {/* Display current user's name or username */}
          {user ? (
            <h1 className="text-xl font-semibold text-gray-900 md:hidden">
              {user.full_name || user.username}
            </h1>
          ) : (
            <div className="text-gray-400 text-xl md:hidden animate-pulse">...</div>
          )}
        </div>
        
        {/* Right section */}
        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <div className="relative">
            <button 
              onClick={toggleNotifications}
              className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 relative"
            >
              <BellRing className="h-5 w-5" />
              {notifications.length > 0 && (
                <span className="absolute top-0 right-0 h-5 w-5 flex items-center justify-center bg-red-500 text-white text-xs rounded-full transform translate-x-1 -translate-y-1">
                  {notifications.length}
                </span>
              )}
            </button>
            
            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg py-2 z-50">
                <div className="px-4 py-2 border-b border-gray-200">
                  <h3 className="font-semibold text-gray-900">Notifications</h3>
                </div>
                <div className="max-h-72 overflow-y-auto">
                  {notifications.length > 0 ? (
                    notifications.map(notification => (
                      <div key={notification.id} className="px-4 py-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0">
                        <div className="flex items-start">
                          <div className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 mr-3 ${
                            notification.type === 'invitation' ? 'bg-primary-100 text-primary-600' : 
                            notification.type === 'update' ? 'bg-green-100 text-green-600' : 
                            'bg-yellow-100 text-yellow-600'
                          }`}>
                            {notification.type === 'invitation' ? <Users className="h-4 w-4" /> : 
                            notification.type === 'update' ? <FileText className="h-4 w-4" /> : 
                            <Clock className="h-4 w-4" />}
                          </div>
                          <div className="flex-1">
                            <p className="text-sm font-medium text-gray-900">{notification.title}</p>
                            <p className="text-xs text-gray-500 mt-1">{notification.time}</p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="px-4 py-6 text-center text-gray-500">
                      <p>No notifications yet</p>
                    </div>
                  )}
                </div>
                {notifications.length > 0 && (
                  <div className="px-4 py-2 border-t border-gray-200">
                    <button className="text-primary-600 hover:text-primary-800 text-sm font-medium">
                      View all notifications
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Profile */}
          <div className="relative">
            <button 
              onClick={toggleProfileMenu}
              className="flex items-center space-x-3 focus:outline-none"
            >
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-primary-600 to-primary-700 text-white flex items-center justify-center font-medium text-sm">
                {user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'U'}
              </div>
              <div className="hidden md:block text-left">
                {user ? (
                  <p className="text-sm font-medium text-gray-900">{user.full_name || user.username}</p>
                ) : (
                  <div className="text-gray-400 text-sm animate-pulse">Loading...</div>
                )}
                <p className="text-xs text-gray-500">Account Owner</p>
              </div>
            </button>
            
            {showProfileMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg py-1 z-50">
                <Link 
                  to="/dashboard/profile" 
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={() => setShowProfileMenu(false)}
                >
                  Your Profile
                </Link>
    
                <div className="border-t border-gray-100 my-1"></div>
                <Link 
                  to="/logout" 
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={logout} 
                >
                  Logout
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;